import { observer } from "mobx-react";
import React, { Component, Fragment } from "react";
import modalIcAdm from "../../../assets/images/modal-ic-adm.svg";
import modalIcGdp from "../../../assets/images/modal-ic-gdp.svg";
import modalIcLegislature from "../../../assets/images/modal-ic-legilslature.svg";
import modalIcPop from "../../../assets/images/modal-ic-pop.svg";
import { State } from "../../../stores/EntityStores/StateStore";
import { MainStore } from "../../../stores/MainStore";
import Image from "../../Image";
import Label from "../../Label";
import VideoPlayer from "../../VideoPlayer";
import DiscoverMoreButton from "../DiscoverMoreButton";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}
interface IState {}
@observer
class CountryModalBody extends Component<IProps, IState> {
  renderCountryProps(selectedState: State) {
    const { store } = this.props;
    return (
      <Fragment>
        <DiscoverMoreButton store={store} />
        <div className={classes.CountryDetailRow}>
          <Image src={modalIcLegislature} alt={"Image"} small />
          <div className={classes.CountryDetailRowText}>
            <Label small left light id={"modal.country.detail.legislature"} />
            <Label small left bold text={selectedState.legislature} />
          </div>
        </div>
        {selectedState.memberStates && (
          <div className={classes.CountryDetailRow}>
            <Image src={modalIcAdm} alt={"Image"} small />
            <div className={classes.CountryDetailRowText}>
              <Label
                small
                left
                light
                id={`modal.country.detail.member-states-${selectedState.id}`}
              />
              <Label small left bold text={selectedState.memberStates} />
            </div>
          </div>
        )}
        <div className={classes.CountryDetailRow}>
          <Image src={modalIcAdm} alt={"Image"} small />
          <div className={classes.CountryDetailRowText}>
            <Label
              small
              left
              light
              id={"modal.country.detail.administrative-center"}
            />
            <Label small left bold text={selectedState.administrativeCenter} />
          </div>
        </div>
        <div className={classes.CountryDetailRow}>
          <Image src={modalIcGdp} alt={"Image"} small />
          <div className={classes.CountryDetailRowText}>
            <Label small left light id={"modal.country.detail.gdp"} />
            <Label small left bold text={selectedState.gdpPerCapita} />
          </div>
        </div>
        <div className={classes.CountryDetailRow}>
          <Image src={modalIcPop} alt={"Image"} small />
          <div className={classes.CountryDetailRowText}>
            <Label small left light id={"modal.country.detail.population"} />
            <Label small left bold text={selectedState.population} />
          </div>
        </div>
        <div className={classes.CountryDetailSource}>
          <a
            href="https://www.imf.org/external/pubs/ft/weo/2018/02/weodata/index.aspx"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Label extraSmall right light id={"modal.country.detail.source"} />
          </a>
        </div>
      </Fragment>
    );
  }

  render() {
    const { store } = this.props;
    const { selectedState } = store;
    return (
      <div className={classes.CountryModalBody}>
        <div className={classes.CountryModalVideoWrapper}>
          <VideoPlayer autoplay expandable store={store} />
        </div>
        <div>{this.renderCountryProps(selectedState)}</div>
      </div>
    );
  }
}
export default CountryModalBody;
